import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Icon } from "@ui5/webcomponents-react";
import { AdminApi, TOKEN_KEY } from "../../api/client";
import { useAuth } from "../../store/auth";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: "home", end: true },
  { to: "/admin/slots", label: "Slots", icon: "calendar" },
  { to: "/admin/schedule", label: "Verfügbarkeit", icon: "history" },
  { to: "/admin/bookings", label: "Buchungen", icon: "appointment-2" },
  { to: "/admin/links", label: "Links", icon: "chain-link" },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const logout = useAuth((s) => s.logout);
  const [email, setEmail] = useState(useAuth.getState().email);

  // Validate the stored token on load and keep the session sliding: /me hands back a
  // freshly-dated token, so active use (and a periodic ping) never expires.
  useEffect(() => {
    let alive = true;
    const refresh = () =>
      AdminApi.me()
        .then((d) => {
          if (!alive) return;
          setEmail(d.email);
          if (d.token) localStorage.setItem(TOKEN_KEY, d.token);
        })
        .catch(() => {});
    refresh();
    const id = setInterval(refresh, 30 * 60 * 1000); // keep a long-open tab logged in
    return () => { alive = false; clearInterval(id); };
  }, []);

  const onLogout = () => {
    logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="brand">
          <span className="logo" role="img" aria-label="Tennis">🎾</span>
          <span className="titles">
            <strong>Calendery</strong>
            <span>tennis-software.de</span>
          </span>
        </div>

        <nav className="admin-nav">
          {NAV.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={({ isActive }) => (isActive ? "active" : "")}>
              <span className="nav-ico"><Icon name={item.icon} style={{ color: "currentColor" }} /></span>
              <span className="nav-label">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          {email && <div className="who">{email}</div>}
          <button type="button" className="logout-btn" onClick={onLogout}>
            <Icon name="log" style={{ color: "currentColor" }} />
            Abmelden
          </button>
        </div>
      </aside>

      <div className="admin-content">
        <main className="admin-body">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
